import { render } from "./dpw-images.vue?vue&type=template&id=0f2dd6c4&scoped=true"
import script from "./dpw-images.vue?vue&type=script&lang=js"
export * from "./dpw-images.vue?vue&type=script&lang=js"

import "./dpw-images.vue?vue&type=style&index=0&id=0f2dd6c4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2dd6c4"]])

export default __exports__